module.exports = __webpack_public_path__ + "img/coach-progress-trophy.a0fdd428.svg";